module.exports = __webpack_public_path__ + "static/img/cqcremen.049dc7cf.png";